import { getCallable } from "../../../_sdk/client";
import { apiName, endpoints } from "./endpoints";
import * as Types from "./types";

export { apiName };

const applyPromotionCodeToSubscription = getCallable<Types.ApplyPromotionCodeToSubscriptionRequest, Types.ApplyPromotionCodeToSubscriptionResponse>(
    apiName,
    "applyPromotionCodeToSubscription",
    {
        ...endpoints.applyPromotionCodeToSubscription,
        composer: request => {
            return {
                url: `/workspaces/${request.workspaceId}/billing/subscriptions/promotion-code`,
                options: {
                    method: "POST",
                    body: JSON.stringify(request)
                }
            };
        }
    });

const getPromotionCode = getCallable<Types.GetPromotionCodeRequest, Types.GetPromotionCodeResponse>(
    apiName,
    "getPromotionCode",
    {
        ...endpoints.getPromotionCode,
        composer: request =>{
            return {
                url: `/workspaces/any/billing/promotion-code/${encodeURIComponent(request.promotionCode)}`,
                options: {
                    method: "GET",
                }
            };
        }
    }
);

export const callables = {
    applyPromotionCodeToSubscription,
    getPromotionCode
};
